<template>
  <span :style="style" class="counter" ref="counter">{{ displayValue }}</span>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'CountUp',
  props: {
    target: {
      type: Number,
      required: true
    },
    style: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      displayValue: 0,
      observer: null
    };
  },
  methods: {
    runCounter() {
      const increment = this.target / 200;
      let currentValue = 0;

      const updateCounter = () => {
        currentValue += increment;
        if (currentValue < this.target) {
          this.displayValue = Math.floor(currentValue);
          requestAnimationFrame(updateCounter);
        } else {
          this.displayValue = this.target;
        }
      };

      updateCounter();
    },
    observeElement() {
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              this.runCounter();
              this.observer.disconnect();
            }
          },
          { threshold: 0.5 }
        );

        this.observer.observe(this.$refs.counter);
      } else {
        this.runCounter();
      }
    }
  },
  mounted() {
    this.observeElement();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>

<style lang="scss" scoped></style>
